export { default as MultipleInsurancesForm } from "./multipleInsurancesForm";
